<template>
  <div class="sortingcenter">
    <div class="bg-white sortingcenter-list pl32 pr32 pt32">
        <h4 class="sortingcenter-list-title">
            <div></div>
            有毒有害列表
        </h4>
        
        <a-table
            :columns="columns"
            :dataSource="backEndList"
            :rowKey="(record) => record.id"
            bordered
            class="mt24"
            :pagination="pagination"
            @change="pageChange"
        >
        </a-table>
    </div>
  </div>
</template>
<script>
export default {
    name: "sortingcenter",
    data() {
        return {
            form: {},
            columns: [
                {
                    title: "时间",
                    dataIndex: "time",
                    key: 'time'
                },
                {
                    title: "品类",
                    dataIndex: "cate_name",
                    key: 'cate_name'
                },
                {
                    title: "重量(kg)",
                    dataIndex: "weight",
                    key: 'weight'
                },
                {
                    title: "收集点",
                    dataIndex: "block_name",
                    key: 'block_name'
                },
                {
                    title: "车牌号",
                    dataIndex: "car_num",
                    key: 'car_num'
                },
                {
                    title: "清运人",
                    dataIndex: "sorting_name",
                    key: 'sorting_name'
                }
            ],
            pagination: {
                //默认当前页
                defaultCurrent: 1,
                defaultPageSize: 10,
                showTotal() {
                    return `共 ${this.total} 条数据`;
                },
                showSizeChanger: true,
                total: 0
            },
            page: 1,
            page_num: 10,
            backEndList: []
        };
    },
    created() {
        this.getFrontEndList(); 
    },
    components: {},
    mounted() {},
    methods: {
        // 头部数据重置
        reset() {
            this.page = 1;
            this.page_num = 10;
            this.$set(this.pagination, "current", 1);
            this.$set(this.pagination, "pageSize", 10);
            this.form = {};
            this.getFrontEndList();
        },
        //查询
        search() {
            this.$set(this.pagination, "current", 1);
            this.$set(this.pagination, "pageSize", 10);
            this.page = 1;
            this.page_num = 10;
            this.getFrontEndList(true);
        },
       
        //获得获取订单列表
        //page:页 page_num每页条数
        getFrontEndList(status = false) {
            this.form.page = this.page;
            this.form.limit = this.page_num;
            this.$api.linan.toxicList(this.form).then((res) => {
                this.pagination.total = res.total * 1;
                res.data.list.forEach((el, index) => {
                    el.id = index;
                });
                this.backEndList = res.data.list;
                status ? this.$message.success("共查询到" + res.total + "条信息") : "";
            });
        },
        // 分页
        pageChange(pagination) {
            this.$set(this.pagination, "current", pagination.current);
            this.$set(this.pagination, "pageSize", pagination.pageSize);
            this.page = pagination.current;
            this.page_num = pagination.pageSize;
            this.getFrontEndList();
        },
    },
};
</script>
<style rel="stylesheet/scss" lang="scss">
    .sortingcenter {
        &-data {
            &-title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .title {
                    display: flex;
                    align-items: center;
                    color: $title-color-black-85;
                    @include pxAndLh(16);
                    font-weight: bold;
                    margin: 0;
                    & > div {
                        width: 5px;
                        height: 20px;
                        background: linear-gradient(180deg, #3f94ec 0%, #0c6ecf 100%);
                        border-radius: 5px;
                        margin-right: 5px;
                    }
                }
                .search {
                    display: flex;
                    align-items: center;
                }
            }
            &-content {
                &-item {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    font-size: 14px;
                    .item {
                        margin-right: 70px;
                        margin-top: 10px;
                        .name {
                            color: #858a90;
                        }
                        .data {
                            color: #363e51;
                            font-weight: 600;
                        }
                        & > div {
                            text-align: center;
                        }
                    }
                }
            }
        }
        &-list {
            &-title {
            display: flex;
            align-items: center;
            color: $title-color-black-85;
            @include pxAndLh(16);
            font-weight: bold;
            margin: 0;
                & > div {
                    width: 5px;
                    height: 20px;
                    background: linear-gradient(180deg, #3f94ec 0%, #0c6ecf 100%);
                    border-radius: 5px;
                    margin-right: 5px;
                }
            }
            &-search {
                display: flex;
            }
        }
    }
</style>